module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image02-367a08887c5295cabd752767f741703f.jpeg";